import Vue from 'vue'
import Vuex from 'vuex'
import core from './core-store'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    core: core
  },
  state: {
    global_sidebar: null,
    app_is_ready: false,
    configs: null,
    settings: {},
    global_popup_message: "",
    show_sim_details_popup: false,
    current_search: '',
    global_alert: {
      show: false,
      message: {
        type: "error",
        text: "Une erreur s'est produite",
        icon: ""
      }
    }
  },
  mutations: {
    update_field: function (state, data) {
      state[data.field] = data.value;
    }
  },
  actions: {

  }
})
